import api from "./apiClient";

export async function createPosProductSubmission(payload) {
  const res = await api.post("/api/pos/inventory/submissions", payload);
  return res.data;
}

export async function listMyPosProductSubmissions(params) {
  const res = await api.get("/api/pos/inventory/submissions", { params });
  return res.data;
}
